import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Document Options tab of the AwesomeDocs config dialog: the corp-wide default
 * output format.
 *
 * Presentational only - it renders the `documentOptions` sub-group handed to it
 * by Adv2ConfigComponent, which remains responsible for loading and saving.
 */
@Component({
  selector: 'app-document-options-tab',
  templateUrl: './document-options-tab.component.html',
  standalone: false,
})
export class DocumentOptionsTabComponent {
  @Input() formGroup: UntypedFormGroup;
}
